import { WifiOff } from 'lucide-react';
import { useSyncExternalStore } from 'react';

import { useT } from '@/str';

function subscribe(onChange: () => void): () => void {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  return () => {
    window.removeEventListener('online', onChange);
    window.removeEventListener('offline', onChange);
  };
}

function useOnline(): boolean {
  return useSyncExternalStore(subscribe, () => navigator.onLine);
}

export function OfflineBar() {
  const t = useT();
  if (useOnline()) return null;
  return (
    <div
      role="status"
      className="bg-bad-tint text-bad flex items-center justify-center gap-2 px-4 py-2 text-sm font-bold"
    >
      <WifiOff size={14} aria-hidden />
      <span>{t.offline}</span>
    </div>
  );
}
